import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "VerifiedInStock",
  "use": "VerifiedInStock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"VerifiedInStock\">\n<path d=\"M23 11.5L20.56 8.71L20.9 5.02L17.29 4.2L15.4 1L12 2.46L8.6 1L6.71 4.19L3.1 5L3.44 8.7L1 11.5L3.44 14.29L3.1 17.99L6.71 18.81L8.6 22L12 20.53L15.4 21.99L17.29 18.8L20.9 17.98L20.56 14.29L23 11.5ZM10.09 16.22L6.29 12.41L7.77 10.93L10.09 13.26L15.94 7.39L17.42 8.87L10.09 16.22Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol